export const formatCurrency = (number?: number, currency?: string): string => {
  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency,
    maximumFractionDigits: 2,
  });

  return formatter.format(Number(number));
};
